// extracted by mini-css-extract-plugin
export var locationCard = "_hk-0";